import React, { ReactNode } from 'react';
import clsx from 'clsx';

interface Props {
  children: ReactNode;
  /** Largeur maximale du contenu, alignée sur celle de l'écran hôte. */
  contentClassName?: string;
}

/**
 * Barre d'actions collée en bas d'un écran défilant (boutons précédent/suivant).
 */
const StickyActionBar = ({ children, contentClassName }: Props) => (
  <div className="sticky bottom-0 z-10 shrink-0 bg-white border-t border-gray-200 shadow-sticky-bar">
    <div className={clsx('mx-auto px-8 w-full', contentClassName)}>
      {children}
    </div>
  </div>
);

export default StickyActionBar;
